import CloseIcon from '@mui/icons-material/Close'
import {
    Alert,
    Box,
    Button,
    Collapse,
    Grid,
    IconButton,
    TextField,
    Typography,
} from '@mui/material'
import { useState } from 'react'
import isEmail from 'validator/lib/isEmail'
import { logEvent } from '../analyticsService'

export const Login: React.FC = () => {
    const [isSSOFlow, setSSOFlow] = useState(false)
    const [isValidEmail, setIsValidEmail] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [emailAddress, setEmailAddress] = useState('')
    const [open, setOpen] = useState(false)

    const ssoClicked = () => {
        setSSOFlow(true)
    }

    const signUp = () => {
        logEvent('SIGNUP', {
            appName: window.location.host,
        })
        window.location.href =
            'https://docs.google.com/forms/d/1sbYr2UuhwZ4cx0TuKKXu067ZmSkFS37pCSYHEbD4DNs/edit'
    }
    const siweLogin = () => {
        logEvent('LOGIN', {
            appName: window.location.host,
            type: 'SIWE',
        })
        window.location.href = `${url()}/oauth/login`
    }
    const url = () =>
        process.env.REACT_APP_NODE_ENV === 'localhost' ? process.env.REACT_APP_HOST_REDIRECT : ''

    const ssoLogin = () => {
        logEvent('LOGIN', {
            appName: window.location.host,
            type: 'SSO',
            userId: emailAddress,
        })
        setOpen(!open)
    }

    const handleEmailChange = (val: string) => {
        if (isEmail(val)) {
            setIsValidEmail(true)
        } else {
            setIsValidEmail(false)
        }
        setEmailAddress(val)
    }

    if (isSSOFlow) {
        return (
            <Box
                style={{
                    height: '100vh',
                    width: '100vw',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/img/rhiza_bg.jpg'})`,
                }}
            >
                <Grid
                    container
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100vh',
                        width: '100vw',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            color="white"
                            height={50}
                            sx={{ fontWeight: 'bold', fontSize: '34px' }}
                        >
                            Single Sign On
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                padding: '5px',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography color="white" sx={{ marginTop: '10px', fontSize: '12px' }}>
                                Your organization uses SSO with Rhiza Health.
                            </Typography>
                            <Typography color="white" sx={{ fontSize: '12px' }}>
                                Please signin using your SSO credentials.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '10px',
                        }}
                    >
                        <Collapse in={open}>
                            <Alert
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                            setOpen(false)
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                sx={{ mb: 2 }}
                            >
                                SSO has not been configured for your organization
                            </Alert>
                        </Collapse>
                        <Box width="300px" sx={{ display: 'flex', flexDirection: 'row' }}>
                            <TextField
                                label={'Email'}
                                onBlur={() => setDirty(true)}
                                size="small"
                                fullWidth
                                color="primary"
                                value={emailAddress}
                                error={dirty && isValidEmail === false}
                                onChange={(event) => handleEmailChange(event.target.value)}
                                sx={{ input: { color: 'white' } }}
                                focused
                            />
                            <Button
                                disabled={!isValidEmail}
                                onClick={() => ssoLogin()}
                                variant="contained"
                                color="primary"
                                sx={{ color: 'white' }}
                                disableElevation={true}
                            >
                                Continue
                            </Button>
                        </Box>
                        <Box sx={{ display: 'flex' }} position="absolute" bottom="30px">
                            <img src="/img/rhiza_logo.png" alt="" height={50} />
                            <Typography
                                color="white"
                                height={50}
                                sx={{
                                    marginLeft: '10px',
                                    marginRight: '10px',
                                    fontWeight: 'bold',
                                    fontSize: '30px',
                                }}
                            >
                                Rhiza
                            </Typography>
                            <Typography color="white" height={50} sx={{ fontSize: '30px' }}>
                                Health
                            </Typography>
                            .
                        </Box>
                    </Box>
                </Grid>
            </Box>
        )
    } else {
        return (
            <Box
                style={{
                    height: '100vh',
                    width: '100vw',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/img/rhiza_bg.jpg'})`,
                }}
            >
                <Grid
                    container
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100vh',
                        width: '100vw',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex' }}>
                        <img src="/img/rhiza_logo.png" alt="" height={50} />
                        <Typography
                            color="white"
                            height={50}
                            sx={{
                                marginLeft: '10px',
                                marginRight: '10px',
                                fontWeight: 'bold',
                                fontSize: '30px',
                            }}
                        >
                            Rhiza
                        </Typography>
                        <Typography color="white" height={50} sx={{ fontSize: '30px' }}>
                            Health
                        </Typography>
                        .
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Button
                            onClick={() => siweLogin()}
                            variant="outlined"
                            color="primary"
                            sx={{
                                marginTop: '10px',
                                width: '300px',
                                ':hover': { bgcolor: '#1975d1', color: 'white' },
                            }}
                            disableElevation={true}
                        >
                            Sign in with Ethereum
                        </Button>
                        <Button
                            onClick={() => ssoClicked()}
                            variant="outlined"
                            color="primary"
                            sx={{
                                marginTop: '10px',
                                width: '300px',
                                ':hover': { bgcolor: '#1975d1', color: 'white' },
                            }}
                            disableElevation={true}
                        >
                            Sign in with Single Sign On
                        </Button>
                        <Button
                            onClick={() => signUp()}
                            variant="outlined"
                            color="primary"
                            sx={{
                                marginTop: '10px',
                                width: '300px',
                                ':hover': { bgcolor: '#1975d1', color: 'white' },
                            }}
                            disableElevation={true}
                        >
                            Sign Up
                        </Button>
                    </Box>
                </Grid>
            </Box>
        )
    }
}
